import { Alert } from "@mui/material";
import React from "react";

const AlertBox = ({ title, type = "info" }) => {
  return <Alert severity={type}>{title}</Alert>;
};

export default AlertBox;
